export const gridColumnCount = (_) => 2;

export const columnPosition = (position, _) => {
  const columnCount = gridColumnCount();
  return position > columnCount
    ? position % columnCount === 0
      ? columnCount
      : 1
    : position;
};
